/** Locale number text with up to `digits` decimals ("0,85"). */
export function formatNumber(value: number, language: string, digits = 2): string {
  return new Intl.NumberFormat(language, { maximumFractionDigits: digits }).format(value);
}

/** Signed locale number text ("+0,1", "−0,25"). */
export function formatSigned(value: number, language: string, digits = 2): string {
  return new Intl.NumberFormat(language, { maximumFractionDigits: digits, signDisplay: 'exceptZero' }).format(value);
}
